module.exports = __webpack_public_path__ + "img/hanoi-branch.1b44ea26.jpg";